package com.nonopn.skydome.common.app.pages.main

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material.LocalContentColor
import androidx.compose.material3.DrawerDefaults
import androidx.compose.material3.DrawerState
import androidx.compose.material3.DrawerValue
import androidx.compose.material3.ModalNavigationDrawer
import androidx.compose.material3.rememberDrawerState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.compositionLocalOf
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.LocalLayoutDirection
import androidx.compose.ui.unit.LayoutDirection
import com.nonopn.skydome.common.app.api.impl.ApiInterface
import com.nonopn.skydome.common.app.api.impl.ApiInterfaceFake
import com.nonopn.skydome.common.app.home.AppModel
import com.nonopn.skydome.common.app.home.HotPreviewApp
import com.nonopn.skydome.common.app.home.LocalIsPreview
import com.nonopn.skydome.common.app.pages.main.model.FakeMainScreenModel
import com.nonopn.skydome.common.app.pages.main.model.MainScreenModel
import com.nonopn.skydome.common.app.pages.main.model.MainScreenModelImpl
import com.nonopn.skydome.common.app.pages.main.window.MainScreenLargeScreen
import com.nonopn.skydome.common.app.pages.main.window.MainScreenTinyScreen
import com.nonopn.skywatcher.design.theme.AppColor
import com.nonopn.skywatcher.design.utils.LocalWindow
import com.nonopn.skywatcher.design.utils.WindowType
import de.drick.compose.hotpreview.HotPreview
import eu.codlab.compose.theme.LocalDarkTheme
import eu.codlab.viewmodel.rememberViewModel

val LocalMapScreenModel = compositionLocalOf<MainScreenModel> {
    error("No MapScreenModel provided")
}

@Composable
fun MainScreen(
    modifier: Modifier,
    appModel: AppModel,
    currentInterface: ApiInterface,
    isAdmin: Boolean = false
) {
    val scope = rememberCoroutineScope()

    val model = if (LocalIsPreview.current) {
        FakeMainScreenModel(false)
    } else {
        rememberViewModel { MainScreenModelImpl(appModel, currentInterface, isAdmin) }
    }

    LaunchedEffect(currentInterface) {
        model.updateCurrentInterface(currentInterface)
    }

    val lightningDrawerState = rememberDrawerState(DrawerValue.Closed)
    model.lightningDrawerState = lightningDrawerState
    model.scope = scope

    val color = if (LocalDarkTheme.current) {
        AppColor.WhiteCream
    } else {
        AppColor.BackgroundBlue
    }

    CompositionLocalProvider(
        LocalContentColor provides color,
        LocalMapScreenModel provides model,
    ) {
        ModalNavigationRightToLeft(
            drawerContent = {
                // RightColumn(Modifier.width(150.dp).fillMaxHeight(), model)
            },
            gesturesEnabled = lightningDrawerState.isOpen,
            drawerState = lightningDrawerState
        ) {
            when (LocalWindow.current) {
                WindowType.SMARTPHONE_TINY -> MainScreenTinyScreen(modifier, model)
                WindowType.SMARTPHONE -> MainScreenTinyScreen(modifier, model)
                WindowType.PHABLET -> MainScreenLargeScreen(modifier, model)
                WindowType.TABLET -> MainScreenLargeScreen(modifier, model)
            }
        }
    }
}

@Composable
private fun ModalNavigationRightToLeft(
    drawerContent: @Composable () -> Unit,
    gesturesEnabled: Boolean,
    drawerState: DrawerState,
    scrimColor: Color = DrawerDefaults.scrimColor,
    content: @Composable () -> Unit,
) {
    val originalDirection = LocalLayoutDirection.current
    val reversedDirection = when (LocalLayoutDirection.current) {
        LayoutDirection.Ltr -> LayoutDirection.Rtl
        LayoutDirection.Rtl -> LayoutDirection.Ltr
    }

    CompositionLocalProvider(LocalLayoutDirection provides reversedDirection) {
        ModalNavigationDrawer(
            drawerContent = drawerContent,
            gesturesEnabled = gesturesEnabled,
            drawerState = drawerState,
            scrimColor = scrimColor
        ) {
            CompositionLocalProvider(LocalLayoutDirection provides originalDirection) {
                content()
            }
        }
    }
}

@HotPreview(widthDp = 1200, heightDp = 800, darkMode = true)
@HotPreview(widthDp = 1200, heightDp = 800, darkMode = false)
@Composable
private fun MainScreenPreview() {
    HotPreviewApp(
        Modifier.fillMaxSize(),
        isDarkTheme = isSystemInDarkTheme(),
        isPreview = true
    ) {
        MainScreen(
            Modifier.fillMaxSize(),
            AppModel.fake(),
            ApiInterfaceFake
        )
    }
}
